/**
 * User Menu — avatar dropdown with sign out and version badge
 */
import { Avatar, Dropdown, Space, Typography } from 'antd'
import { UserOutlined, LogoutOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import { useTranslation } from 'react-i18next'
import { authStore, authActions } from '@store/authStore'
import { gatewayClient } from '@infrastructure/api'
import { useVersionQuery } from '@queries/version'
import { ROUTES } from '@shared/constants'

const { Text } = Typography

export function UserMenu() {
  const { t } = useTranslation()
  const { user } = useSnapshot(authStore)
  const navigate = useNavigate()
  const { data } = useVersionQuery()

  const handleLogout = () => {
    authActions.logout()
    gatewayClient.logout()
  }

  const versionLabel = data
    ? `v${data.version}${data.buildSha ? ` · ${data.buildSha.slice(0, 7)}` : ''}`
    : null

  const items = [
    {
      key: 'user-info',
      label: (
        <div style={{ padding: '4px 0' }}>
          <Text strong>{user?.displayName}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }}>{user?.email}</Text>
        </div>
      ),
      disabled: true,
    },
    { type: 'divider' as const },
    ...(versionLabel
      ? [
          {
            key: 'whats-new',
            label: (
              <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11 }}>
                {versionLabel} →
              </span>
            ),
            onClick: () => navigate(ROUTES.WHATS_NEW),
          },
          { type: 'divider' as const },
        ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('common.signOut'),
      onClick: handleLogout,
    },
  ]

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Space style={{ cursor: 'pointer' }}>
        <Avatar
          size="small"
          icon={<UserOutlined />}
          src={user?.avatarUrl}
          style={{ backgroundColor: '#00263E' }}
        />
        <Text style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {user?.displayName}
        </Text>
      </Space>
    </Dropdown>
  )
}

export default UserMenu
